/* Killerani draft "Kartenladen", homepage behaviour. Uses Motion (motion.dev, global `Motion`) when present.
   One orchestrated moment: the drop card is dealt in on load. Everything else answers a person's action.
   With reduced motion: no deal, no rolling digits, instant jumps. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const M = window.Motion || null;
  const ease = [0.2, 0.8, 0.2, 1];
  const done = () => document.documentElement.classList.remove('kn-anim');

  /* ---------- the deal ---------- */
  function deal(hero) {
    const card = hero.querySelector('[data-kn-pcard]');
    const backs = hero.querySelectorAll('.kn-pack__back');
    if (!card) return done();
    if (reduce || !M) return done();
    const { animate, stagger } = M;
    animate(backs, { opacity: [0, 1], y: [40, 0] }, { duration: 0.6, delay: stagger(0.08), ease });
    animate(card,
      { opacity: [0, 1], x: [140, 0], y: [-90, 0], rotate: [16, 0], scale: [0.86, 1] },
      { type: 'spring', bounce: 0.32, duration: 1.15, delay: 0.25 }
    ).then(() => { card.style.transform = ''; });
    requestAnimationFrame(done);
  }

  /* ---------- the drop card: flip, colour, shine ---------- */
  function initCard(hero) {
    const card = hero.querySelector('[data-kn-pcard]');
    if (!card) return;
    const faces = card.querySelectorAll('.kn-pcard__face');
    card.addEventListener('click', () => {
      const on = card.getAttribute('aria-pressed') !== 'true';
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
      faces[0].setAttribute('aria-hidden', on ? 'true' : 'false');
      faces[1].setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    const btns = hero.querySelectorAll('[data-kn-g]');
    btns.forEach((b) => b.addEventListener('click', () => {
      card.dataset.g = b.dataset.knG;
      card.dataset.tone = b.dataset.tone || 'light';
      btns.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      if (M && !reduce) M.animate(card, { scale: [0.97, 1] }, { type: 'spring', bounce: 0.4, duration: 0.5 });
    }));
    if (reduce) return;
    card.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const r = card.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width; const py = (e.clientY - r.top) / r.height;
      card.style.setProperty('--ry', ((px - 0.5) * 10).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - py) * 8).toFixed(2) + 'deg');
      card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      card.classList.add('is-hot');
    });
    card.addEventListener('pointerleave', () => {
      card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg');
      card.classList.remove('is-hot');
    });
  }

  /* ---------- countdown to an absolute launch time ---------- */
  function initCountdown(hero) {
    const launch = Date.parse(hero.dataset.launch || '');
    if (!launch) return;
    const units = {};
    hero.querySelectorAll('[data-kn-unit]').forEach((el) => { units[el.dataset.knUnit] = el; });
    const pre = hero.querySelectorAll('[data-kn-prelaunch]');
    const live = hero.querySelector('[data-kn-live]');
    const set = (el, val) => {
      if (!el || el.textContent === val) return;
      el.textContent = val;
      if (M && !reduce && el.dataset.ready) M.animate(el, { y: ['-70%', '0%'], opacity: [0, 1] }, { duration: 0.42, ease });
      el.dataset.ready = '1';
    };
    let timer = 0;
    const tick = () => {
      const left = launch - Date.now();
      if (left <= 0) {
        pre.forEach((n) => { n.hidden = true; });
        if (live) live.hidden = false;
        clearInterval(timer);
        return;
      }
      const s = Math.floor(left / 1000);
      set(units.d, String(Math.floor(s / 86400)).padStart(2, '0'));
      set(units.h, String(Math.floor((s % 86400) / 3600)).padStart(2, '0'));
      set(units.m, String(Math.floor((s % 3600) / 60)).padStart(2, '0'));
      set(units.s, String(s % 60).padStart(2, '0'));
    };
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- shop filter with FLIP ---------- */
  function initShop(shop) {
    const chips = shop.querySelectorAll('[data-kn-filter]');
    const items = [...shop.querySelectorAll('[data-kn-item]')];
    chips.forEach((chip) => chip.addEventListener('click', () => {
      const f = chip.dataset.knFilter;
      chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
      const before = new Map(items.filter((i) => !i.hidden).map((i) => [i, i.getBoundingClientRect()]));
      items.forEach((i) => { i.hidden = !(f === 'all' || i.dataset.cat === f); });
      if (!M || reduce) return;
      items.filter((i) => !i.hidden).forEach((i, n) => {
        const a = before.get(i); const b = i.getBoundingClientRect();
        if (a) {
          const dx = a.left - b.left; const dy = a.top - b.top;
          if (dx || dy) M.animate(i, { x: [dx, 0], y: [dy, 0] }, { type: 'spring', bounce: 0.18, duration: 0.55 });
        } else {
          M.animate(i, { opacity: [0, 1], scale: [0.94, 1] }, { duration: 0.35, delay: n * 0.03, ease });
        }
      });
    }));
  }

  /* ---------- killers binder ---------- */
  function initBinder(sec) {
    const row = sec.querySelector('[data-kn-row]');
    if (!row) return;
    const slots = [...row.querySelectorAll('[data-kn-drop]')];
    const tabs = [...sec.querySelectorAll('[data-kn-drop-tab]')];
    const behavior = reduce ? 'auto' : 'smooth';
    const pad = () => parseFloat(getComputedStyle(row).paddingLeft) || 0;
    const go = (slot) => row.scrollTo({ left: slot.offsetLeft - pad(), behavior });

    tabs.forEach((t) => t.addEventListener('click', () => {
      const slot = slots.find((s) => s.dataset.knDrop === t.dataset.knDropTab);
      if (slot) go(slot);
    }));
    sec.querySelectorAll('[data-kn-step]').forEach((b) => b.addEventListener('click', () => {
      row.scrollBy({ left: Number(b.dataset.knStep) * row.clientWidth * 0.8, behavior });
    }));
    const mark = () => {
      const x = row.scrollLeft + pad() + 10;
      let cur = slots[0];
      for (const s of slots) { if (s.offsetLeft <= x) cur = s; }
      tabs.forEach((t) => t.setAttribute('aria-pressed', cur && t.dataset.knDropTab === cur.dataset.knDrop ? 'true' : 'false'));
    };
    let raf = 0;
    row.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });

    // flip one card at a time
    row.addEventListener('click', (e) => {
      const card = e.target.closest('[data-ka-card]');
      if (!card || row.dataset.dragged === '1') return;
      const on = card.getAttribute('aria-pressed') !== 'true';
      row.querySelectorAll('[data-ka-card][aria-pressed="true"]').forEach((c) => c.setAttribute('aria-pressed', 'false'));
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // drag to scroll with a mouse; touch scrolls natively
    let down = false; let sx = 0; let sl = 0; let moved = 0;
    row.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = 0; sx = e.clientX; sl = row.scrollLeft; row.dataset.dragged = '0';
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
      if (moved > 6) { row.classList.add('is-dragging'); row.scrollLeft = sl - dx; row.dataset.dragged = '1'; }
    });
    window.addEventListener('pointerup', () => {
      if (!down) return; down = false; row.classList.remove('is-dragging');
      setTimeout(() => { row.dataset.dragged = '0'; }, 0);
    });
    mark();
  }

  /* ---------- dock: visible, progress, active link ---------- */
  function initDock() {
    const dock = document.querySelector('[data-kb-dock]');
    if (!dock) return;
    dock.classList.add('is-on');
    const bar = dock.querySelector('[data-kb-progress]');
    const links = [...dock.querySelectorAll('[data-kb-dock-link]')]
      .map((a) => ({ a, el: document.getElementById((a.getAttribute('href') || '').split('#')[1] || '') }))
      .filter((x) => x.el);
    let raf = 0;
    const paint = () => {
      const max = document.documentElement.scrollHeight - innerHeight;
      if (bar) bar.style.setProperty('--p', max > 0 ? (scrollY / max).toFixed(4) : 0);
      let cur = null;
      links.forEach((x) => { if (x.el.getBoundingClientRect().top < innerHeight * 0.45) cur = x; });
      links.forEach((x) => x.a.classList.toggle('is-active', x === cur));
    };
    addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, { passive: true });
    paint();
  }

  const boot = () => {
    document.querySelectorAll('[data-kn-hero]').forEach((h) => { initCard(h); initCountdown(h); deal(h); });
    document.querySelectorAll('[data-kn-shop]').forEach(initShop);
    document.querySelectorAll('[data-kn-killers]').forEach(initBinder);
    initDock();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
